import { getAsync, postAsync } from '../../../../shared/api.service'

// The Billing staff APIs (rapid-api-billing's /api/ddd/billing-sys/...),
// called straight at REACT_APP_API_BILLING with the staff session (never
// through the gateway). Like packages-api: plain functions, each resolving to
// the response body and, on failure, throwing the response ({ status, data:
// { code, message } }), so serverMessage(err) reads the server's sentence and
// <ErrorReference error={err} /> its request id. Module functions keep one
// identity for the life of the app, so they are safe in any effect's deps.
//
// Verbs on SYS_BILLING: read = both GETs; update = recompute.
const base = () => process.env.REACT_APP_API_BILLING

// Whether this build knows where the billing service is (a build without it
// hides the section).
export const billingAvailable = () => Boolean(base())

const unwrap = async call => {
  try {
    const result = await call()
    return result ? result.data : undefined
  } catch (err) {
    throw (err && err.response) || err
  }
}

const PATH = 'api/ddd/billing-sys'

// { published: { id, n, publishedAt, contents }, draft: { id, n } | null }
export const getCatalog = () => unwrap(() => getAsync(base(), `${PATH}/catalog`))
// { stored, computed, inputsHash, matchesStored, sourceOfTruth } or, for a
// deleted organization, the same with computed null and skipped: 'deleted'
export const getEntitlements = organizationID =>
  unwrap(() => getAsync(base(), `${PATH}/organizations/${encodeURIComponent(String(organizationID))}/entitlements`))
// organizationIDs: 1..n ids -> { results: [...] }
export const recompute = organizationIDs => unwrap(() => postAsync(base(), `${PATH}/recompute`, { organizationIDs }))
